import React from 'react'

//
import { SiteDataContext } from '../../../components/page-wrapper'
import { LoadMore, IntegrationListing } from '../../../storybook'
import { IntegrationTypes } from '../../../storybook/Integration'
import { useWindowWidth } from '../../../storybook/hooks'
import { getIntegrationLabel, getIntegrationLabelColor } from '../../../utils/common'
import { getMicroCopy } from '../../../utils/microcopy'
import { useMicroCopyData } from '@/src/context/MicroCopyContext'

const VIEWPORT_7 = 720

const BlockIntegrationListing = ({
  data: { title, preface, description, extra, primaryAction, contentList, integrations },
  limit = 9
}) => {
  const microCopyData = useMicroCopyData()
  const { lang, market } = React.useContext(SiteDataContext)
  const [offsetToShow, setOffsetToShow] = React.useState(limit)

  const windowWidth = useWindowWidth()

  const integrationSize =
    windowWidth > VIEWPORT_7 ? IntegrationTypes.medium : IntegrationTypes.large

  const integrationsToShow = integrations ? [...integrations] : []
  integrationsToShow.sort((a) => (a.label ? -1 : 0))
  integrationsToShow.sort((a, b) => {
    if (a.label === 'new' && b.label !== 'new') {
      return -1
    }
    if (a.label === 'new' && b.label === 'new') {
      return 0
    }
    if (a.label !== 'new' && b.label === 'new') {
      return 1
    }
    return -1
  })

  const cards = integrationsToShow.slice(0, offsetToShow).map((node) => {
    const { id, logo, slug, title, label, categories = [], markets } = node
    const isAvailableInMarket = markets.find(
      (m) => m.countryIsoCode?.toLowerCase() === market.isoCode?.toLowerCase()
    )
    const isEnglishGlobal = market.isoCode.toLowerCase() === 'xx' && lang === 'en'

    return {
      id,
      title,
      type: categories.map((cat) => cat.title).join(', '),
      size: integrationSize,
      label: getIntegrationLabel(label),
      labeltype: getIntegrationLabelColor(label),
      url: isAvailableInMarket
        ? `/${extra.slugPrefix}/integrations/${slug}`.replace('//', '/')
        : isEnglishGlobal
        ? `/en/integrations/${slug}`
        : '',
      logo: logo?.url || ''
    }
  })

  return (
    <IntegrationListing
      title={title || ''}
      preface={preface || null}
      description={description || ''}
      items={cards}
      primaryAction={primaryAction || null}
      contentList={contentList || []}
    >
      {offsetToShow < integrationsToShow.length && (
        <LoadMore
          current={offsetToShow}
          total={integrationsToShow.length}
          loadLabel={getMicroCopy({ key: `paginationLoadMore`, data: microCopyData[lang] })}
          separationLabel={getMicroCopy({ key: `paginationOf`, data: microCopyData[lang] })}
          handleLoadMore={() => setOffsetToShow(offsetToShow + limit)}
        />
      )}
    </IntegrationListing>
  )
}

export default BlockIntegrationListing
